import { useEffect } from 'react';
import { useFormState } from 'react-hook-form';

const scrollToErrorMessage = (errors: any) => {
  const errorsNames = Object.keys(errors);

  if (!errorsNames.length) {
    return;
  }

  const node = document.getElementById(`error-msg-${errorsNames[0]}`);

  if (node) {
    node.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
  }
};

const FormErrorMessageScroller = ({ children, beforeScroll }: any) => {
  const formState = useFormState();
  useEffect(() => {
    if (formState?.isSubmitting || formState?.isValidating) {
      if (typeof beforeScroll === 'function') {
        beforeScroll();
      }

      scrollToErrorMessage(formState.errors);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formState]);

  return children;
};

export default FormErrorMessageScroller;
